import { ColDef, ICellRendererParams } from '@ag-grid-community/core'
import { AgGridReact } from '@ag-grid-community/react'
import GridNoResultsOverlay from 'components/GridNoResultsOverlay'
import dayjs from 'dayjs'

import {
  ContributionReportResponseManyDto,
  ContributionReportResponseOneDto,
} from 'modules/contribution-report-service/dtos'
import React, { useMemo } from 'react'
import ContributionReportProgressCell from './ContributionReportProgressCell'
import ContributionReportDownloadCell from './ContributionReportDownloadCell'

export default function ContributionReportTable({
  reports,
  isLoading,
}: {
  reports?: ContributionReportResponseManyDto
  isLoading?: boolean
}) {
  /* --------------------------------- States --------------------------------- */
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: true,
      filter: false,
      editable: false,
      suppressMovable: false,
    }),
    []
  )

  const columnDefs = useMemo<ColDef<ContributionReportResponseOneDto>[]>(
    () => [
      {
        headerName: 'Year',
        field: 'year' as keyof ContributionReportResponseOneDto,
        width: 100,
      },
      {
        headerName: 'Progress',
        width: 400,
        cellRenderer: ContributionReportProgressCell,
      },
      {
        headerName: 'Generated At',
        flex: 1,
        cellRenderer: ({
          data,
        }: ICellRendererParams<ContributionReportResponseOneDto>) => {
          return (
            <span>{dayjs(data?.createdAt).format('MM/DD/YYYY HH:mm')}</span>
          )
        },
      },
      {
        headerName: 'Actions',
        width: 220,
        cellRenderer: ContributionReportDownloadCell,
        sortable: false,
        filter: false,
      },
    ],
    []
  )
  /* ---------------------------------- Doms ---------------------------------- */
  return (
    <div className="ag-theme-alpine" style={{ height: '600px', width: '100%' }}>
      <AgGridReact<ContributionReportResponseOneDto>
        defaultColDef={defaultColDef}
        columnDefs={columnDefs}
        rowData={isLoading ? undefined : (reports?.companies ?? [])}
        suppressRowClickSelection
        noRowsOverlayComponent={GridNoResultsOverlay}
      />
    </div>
  )
}
